import { render, staticRenderFns } from "./Artisans.vue?vue&type=template&id=7d98b122&scoped=true"
import script from "./Artisans.vue?vue&type=script&lang=js"
export * from "./Artisans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d98b122",
  null
  
)

export default component.exports